<template>
  <div>
    <div id="footer_left">
      <!-- <span>审批流程:</span> -->
      <div class="footer_left_content">
        <div v-for="(item,index) in checkData" :key="index">
          <span class="left_1">
            <b v-if="item.condition===0">普通:</b>
            <b v-if="item.condition===1">会签:</b>
            <b v-if="item.condition===2">或签:</b>
            <!-- 首先判断是角色、人员、职务，再次判断是单个人还是多个人(数组) -->
            <span
              class="nameClass"
              :class="getClass(item2.processorCerType)"
              v-for="(item2, index2) in item.processorCerVoList"
              :key="index2"
              style="margin-left:8px;"
            >{{item2.processorCerName}}</span>
          </span>
          <a-icon v-if="index < checkData.length - 1" theme="filled" type="right-circle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'historyAduiProcess',
  props: {
    rowData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      approverData: [
        {
          name: ['王明', '刘涛成'],
          status: 2
        },
        {
          name: ['江明', '刘微微'],
          status: 1
        }
      ],
      checkData: this.rowData
    }
  },
  watch: {
    rowData (valList) {
      this.checkData = valList
    }
  },
  methods: {
    getClass (val) {
      switch (val) {
        case 1:
          return 'personClass'
        case 2:
          return 'roleClass'
        case 3:
          return 'dutyClass'
      }
    },
    getMyStyle (lengthVal) {
      return lengthVal * 70 + 120 + 'px'
    }
  }
}
</script>

<style scoped>
#footer_left {
  padding: 16px 0;
  overflow-x: auto; /* 关键属性1：启用横向滚动 */
  -webkit-overflow-scrolling: touch; /* 移动端流畅滚动 */
}

.footer_left_content {
  display: flex;
  flex-wrap: nowrap; /* 关键属性2：禁止换行 */
  min-width: max-content; /* 关键属性3：保证内容不压缩 */
}

.left_1 {
  margin: 0 10px;
  border: 1px dashed #ccc;
  padding: 10px;
  flex-shrink: 0; /* 关键属性4：禁止子项收缩 */
  white-space: nowrap; /* 关键属性5：保持内容不换行 */
}

/* 可选：自定义滚动条样式 */
#footer_left::-webkit-scrollbar {
  height: 8px;
}
#footer_left::-webkit-scrollbar-track {
  background: #f1f1f1;
}
#footer_left::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.nameClass {
  font-size: 14px;
  color: #ffffff;
  padding: 6px 4px;
  border-radius: 6px;
}
.personClass {
  background-color: #5585ac;
}
.roleClass {
  background-color: #42b983;
}
.dutyClass {
  background-color: #b37bfd;
}
</style>



// WEBPACK FOOTER //
// src/views/common/historyAduiProcess.vue